export default __webpack_public_path__ + "static/media/clipboard.a51f85cb.svg";